export default {
  "hero_h1_line1": "CSSBuy Spreadsheet",
  "hero_h1_line2": "Atualizado 2026",
  "hero_h1_full": "CSSBuy Spreadsheet Atualizado 2026 – A Melhor Lista de Produtos CSSBuy",
  "hero_subheadline": "Encontre os melhores CSSBuy Spreadsheets atualizados diariamente com produtos verificados, preços baixos e qualidade premium.",
  "hero_cta_primary": "cssbuy sheet",
  "hero_cta_secondary": "buy it now",
  "hero_trust_updated": "Atualizado diariamente",
  "hero_trust_verified": "Produtos verificados",
  "hero_trust_guide": "Guia seguro para iniciantes",
  "problem_title": "Por que a maioria das pessoas erra ao usar CSSBuy Spreadsheet?",
  "problem_text": "A maioria dos usuários encontra spreadsheets desatualizados, produtos falsos ou links quebrados. Navegar por milhares de produtos sem uma curadoria adequada resulta em perda de tempo e dinheiro.",
  "solution_title": "O melhor CSSBuy Spreadsheet centralizado",
  "solution_text": "Nosso sistema de CSSBuy Spreadsheet organizado e atualizado resolve isso com listas filtradas, comparações e dados reais verificados semanalmente.",
  "solution_feature_1": "Atualizações diárias",
  "solution_feature_2": "Produtos mais comprados",
  "solution_feature_3": "Sneakers / Streetwear / Luxury",
  "solution_feature_4": "Links organizados",
  "categories_title": "Explorar Por Categoria",
  "categories_subtitle": "Navegue pelas categorias mais populares e encontre exatamente o que procura",
  "seo_hub_label": "SEO Hub",
  "seo_hub_title": "Guia CSSBuy Spreadsheet 2026",
  "seo_hub_desc": "Aprenda tudo sobre como utilizar CSSBuy Spreadsheets para encontrar os melhores produtos. Nosso guia completo cobre desde iniciantes até usuários avançados, com dicas de segurança, comparações e recomendações atualizadas.",
  "seo_hub_read": "Ler Artigo Completo",
  "comparison_title": "Comparação: CSSBuy Spreadsheet vs Concorrentes",
  "comparison_subtitle": "Veja como o CSSBuy se compara com outras plataformas populares em 2026",
  "comparison_col_platform": "Plataforma",
  "comparison_col_update": "Atualização",
  "comparison_col_quality": "Qualidade",
  "comparison_col_trust": "Confiança",
  "comparison_col_seo": "Volume SEO",
  "comparison_daily": "Diário",
  "comparison_weekly": "Semanal",
  "comparison_high": "Alta",
  "comparison_medium": "Média",
  "comparison_very_high": "Muito alto",
  "comparison_high_volume": "Alto",
  "comparison_medium_volume": "Médio",
  "feature_title": "Por que escolher nosso CSSBuy Spreadsheet",
  "feature_subtitle": "Características que fazem a diferença na sua experiência de compra",
  "feature_col_category": "Categoria",
  "feature_col_update": "Atualização",
  "feature_col_quality": "Qualidade",
  "feature_col_popularity": "Popularidade",
  "trust_title": "Transparência e Confiança",
  "trust_text_1": "Não vendemos produtos — somos apenas um guia educacional independente.",
  "trust_text_2": "Todos os links são de terceiros e redirecionam para o site oficial.",
  "trust_text_3": "Transparência total sobre nossa metodologia de curadoria.",
  "trust_text_4": "Aviso de afiliados: podemos receber comissões por links qualificados.",
  "cta_title": "Acesse agora o CSSBuy Spreadsheet atualizado",
  "cta_subtitle": "Milhares de produtos verificados esperando por você. Não perca tempo com listas desatualizadas.",
  "cta_button": "Ver Spreadsheet Completo",
  "cta_secondary_button": "Acessar Site Principal",
  "article_breadcrumb_home": "Início",
  "article_breadcrumb_blog": "Blog",
  "article_back_home": "← Voltar ao Início",
  "article_reading_time": "Tempo de leitura: 8 minutos",
  "article_published": "Publicado em 27 de Junho de 2026",
  "article_author": "Equipe CSSBuy.watch"
};